var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.records.length
    ? _c(
        "div",
        [
          _c(
            "v-popover",
            { attrs: { "auto-hide": true } },
            [
              _c("button", { staticClass: "btn btn-default" }, [
                _c("i", { staticClass: "icon-fa icon-fa-history" }),
              ]),
              _vm._v(" "),
              _c("template", { slot: "popover" }, [
                _c("div", [
                  _c("table", { staticClass: "table mt-0 table-sm" }, [
                    _c(
                      "tbody",
                      _vm._l(_vm.records, function (r) {
                        return _c("tr", [
                          _c("td", [
                            _vm._v(_vm._s(_vm.printDate(r.created_at))),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(r.qty))]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [_c("UserName", { attrs: { id: r.user_id } })],
                            1
                          ),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }